import React from 'react'
import './about.css'
const About = () => {
    return (
        <section className="eventmain">
            <div className="event1">
            <span className="event1text">About Us</span>
            </div>
            
            <div className='abouttext'>
            The School of Engineering has a dedicated T&amp;P Cell housed in the Dean's building of the Engineering 
            (SoE) premises of Tezpur University, with all the required infrastructure. The cell has exclusive 
            interview room, conference room and ICT facility for conducting online test. Besides producing 
            quality-oriented manpower, Tezpur University also facilitates appropriate utilization of such
             personnel. Acting as the interface, the Training &amp; Placement Cell of the University facilitates
              the process of placement of students passing out from the Institute besides collaborating with
               leading organizations and institutes in setting up of internship and training program of students. <br/> <br/>


            The office liaises with various industrial establishments, corporate houses etc which conduct campus 
            interviews and select graduate and post-graduate students from all disciplines. The Training &amp; Placement
             Office provides the infra-structural facilities to conduct group discussions, tests and interviews 
             besides catering to other logistics. The Office interacts with many industries in the country, of which
              nearly 300 companies visit the campus for holding campus interviews. The industries which approach the
               institute come under the purview of : <br/> <br/>


→ PSU's (Public Sector Undertaking) <br/>

→ Core Engineering industries <br/>

→ IT &amp; IT enabled services <br/>

→ Manufacturing Industries <br/>

→ Consultancy Firms <br/>

→ Finance Companies <br/>

→ Management Organizations <br/>

→ R &amp; D laboratories etc <br/>

→ Central Government Organization <br/>

→ Educational Institutes <br/> <br/>


The placement season runs through the course of the year commencing the second week of July 
through to June. Pre-Placement Talks are also conducted in this regard as per mutual convenience.
 Job offers, dates of interviews, selection of candidates etc. are announced through the Training &amp;
  Placement Office. The Placement Office is assisted by a committee comprising representatives of students 
  from the under-graduation and post-graduation. The committee evolves a broad policy framework every year
   besides a set of rules which are inviolable. Student members are closely co-opted in implementing these 
   policy decisions. <br/><br/>


An invitation for campus hiring, Training &amp; Placement Cell, School of Engineering. <br/> <br/>


Dear esteemed recruiters, <br/>

Greetings From the School of Engineering (Tezpur University) <br/> <br/>

We would like to extend our sincere gratitude to all the esteemed organizations for their re- lentless 
support in transforming Tezpur University to one of the world class universities. It gives us immense
 pleasure to extend a warm and cordial invitation in our Silver Jubilee year to participate in the Campus
  Recruitment Process of Tezpur University. <br/> <br/>

Our sincere effort in developing a highly collaborative relationship as a part of our Industry 
–Academia effort has further enhanced the skills of our students who come through the reputed Joint
 Entrance Examination (JEE). Tezpur University is Accredited “A” by NAAC and majority of our Engineering
  disciplines are NBA Accredited. Internships ranging from two months to one year both for our BTech and
   MTech are regular feature of our programmes. We add value to our students through effective soft skill 
   and Technical grooming sessions and arrange highly interactive training sessions by industry experts
    from various domains. We are a reservoir, where dynamic and highly skilled young professionals are moulded
     in different fields to meet the ever increasing need of the industries and academic institutions. Our 
     students get a lot of industrial exposure by their frequent industrial visits.<br/> <br/>

We leave no stone unturned to groom our students, not only in their chosen discipline, but also focus to instill
 in them all the necessary qualities to equip them to be an asset for the industries and the nation with high 
 morale, socially committed and ethical individuals. The Student Placement coordinators of the “Training and 
 Placement Cell” is a team of highly motivated students who forms a strong linkage between the companies &amp;
  students to ensure a smooth Placement process which in-turn develop their student leadership skills. Thus 
  we assure you that future Industry leaders with all the required competencies are available here. Our recruiters
   include the top global giants both from the Public sector and private sector. All our Technical departments are
    very open to promote innovative and R&amp;D collaborative industrial problems, as projects to develop a strong
     liaison with our stakeholders.<br/> <br/>

We eagerly look forward to host you at our world class University for internships and final campus placement 
processes, already started from May 2018 for the batch of 2019. <br/> <br/>

We invite all our esteemed recruiters to visit our campus and conduct the entire process in person. 
We also have ample infrastructure to conduct mass online test, Skype interview, video-conferencing 
and telephonic rounds. Please feel free to contact the “Training &amp; Placement Cell” should you require
 any further information /clarification. I wish the Campus recruitment programme a great success and 
 shall always look forward to a mutually beneficial relationship with the recruiters. <br/> <br/>



            </div>
        </section>
        
    )
}

export default About
